import { render, staticRenderFns } from "./bjgl-list.vue?vue&type=template&id=4c499ab9&"
import script from "./bjgl-list.vue?vue&type=script&lang=ts&"
export * from "./bjgl-list.vue?vue&type=script&lang=ts&"
import style0 from "./bjgl-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports